<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!!id || hasItens"
                        :options="form.tipos"
                        :validations="validations.tipo"
                        label="Tipo de exame"
                        text-field="nome"
                        v-model="model.tipoId"
                        value-field="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome do kit"
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <Items
            :tipoExameId="model.tipoId"
            :itens="model.itens"
        />
    </div>
</template>

<script>
// Components.
import Items from './components/item/Index'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    components: { Items },
    computed: {
        validations() {

            return {
                tipo: { required: true },
                nome: { min: 3, max: 150, required: true },
            }
        },
        hasItens() {

            return Array.isArray(this.model.itens) && this.model.itens.length > 0
        }
    },
    created() {

        this.repositories = {
            kitExame: this.getConectaSusRepository('parametrizacao.kitExame'),
        }

        this.load()
    },
    data: () => ({
        model: {},
        form: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.kitExame.edit(this.id)
                : this.repositories.kitExame.create()

            request
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!this.hasItens) {

                        this.showValidationNotification('Inclua pelo menos um exame no Kit antes de salvar!')
                    }

                    if (!valid || !this.hasItens) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.kitExame.update(this.id, this.prepareData())
                        : this.repositories.kitExame.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const kit = this.clone(this.model)

            kit.itens.map(item => {

                item.exameId = item.exame.id

                delete item.exame
            })

            return this.camelObjectKeysToSnakeRecursive(kit)
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        id: { type: Number }
    },
}
</script>